// extracted by mini-css-extract-plugin
export default {"tick":"Tick--tick--eBWfe"};